<!-- Messages toggle button -->
<button mat-icon-button (click)="openPanel()" #messagesOrigin [matTooltip]="'Inbox'">
    @if (unreadCount > 0) {
        <span class="absolute left-0 right-0 top-0 flex h-3 items-center justify-center">
            <span class="ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-green-600 px-1 text-xs font-medium text-white">
                {{ unreadCount > 99 ? '99+' : unreadCount }}
            </span>
        </span>
    }
    <mat-icon [svgIcon]="'heroicons_outline:inbox'"></mat-icon>
</button>

<!-- Messages panel -->
<ng-template #messagesPanel>
    <div class="fixed inset-0 flex flex-col overflow-hidden shadow-lg sm:static sm:inset-auto sm:w-96 sm:min-w-96 sm:max-w-96 sm:rounded-2xl">
        <!-- Header -->
        <div class="flex shrink-0 items-center bg-green-600 py-4 pl-6 pr-4 text-white">
            <div class="-ml-1 mr-3 sm:hidden">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="text-current icon-size-5" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Unread Messages</div>
            <div class="ml-auto">
                <button 
                    mat-icon-button 
                    [matTooltip]="'Open Mailbox'"
                    (click)="openMailbox()"
                >
                    <mat-icon class="text-current icon-size-5" [svgIcon]="'heroicons_outline:arrow-top-right-on-square'"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="bg-card relative flex flex-auto flex-col overflow-y-auto overflow-x-hidden sm:max-h-120">
            <!-- Loading state -->
            @if (isLoading) {
                <div class="flex items-center justify-center py-12">
                    <div class="text-gray-500">Loading...</div>
                </div>
            }

            <!-- Unread Emails List -->
            @if (!isLoading) {
                <div class="divide-y">
                    @for (mail of unreadEmails; track trackByFn($index, mail)) {
                        <div 
                            class="group flex cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors overflow-hidden"
                            (click)="openEmail(mail)"
                        >
                            <div class="flex flex-auto py-4 pl-6 pr-4 overflow-hidden">
                                <!-- Unread indicator -->
                                <div class="mr-3 mt-1.5 flex-shrink-0">
                                    <span class="flex h-2 w-2 rounded-full bg-green-500"></span>
                                </div>
                                
                                <!-- Email content -->
                                <div class="flex flex-auto flex-col min-w-0 overflow-hidden">
                                    <!-- Sender and date -->
                                    <div class="flex items-center justify-between gap-2">
                                        <div class="font-semibold truncate flex-1 min-w-0">
                                            {{ getSenderName(mail) }}
                                        </div>
                                        <div class="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap flex-shrink-0">
                                            {{ mail.date | date: 'MMM d, h:mm a' }}
                                        </div>
                                    </div>
                                    
                                    <!-- Sender email (if different from name) -->
                                    @if (getSenderEmail(mail) && getSenderEmail(mail) !== getSenderName(mail)) {
                                        <div class="text-xs text-gray-500 dark:text-gray-400 truncate">
                                            {{ getSenderEmail(mail) }}
                                        </div>
                                    }
                                    
                                    <!-- Subject -->
                                    <div class="font-medium truncate mt-1">
                                        {{ mail.subject || '(No subject)' }}
                                    </div>
                                    
                                    <!-- Preview -->
                                    @if (mail.content) {
                                        <div class="text-sm text-gray-600 dark:text-gray-400 line-clamp-2 mt-1 break-words">
                                            {{ mail.content }}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }

                    <!-- No unread emails -->
                    @if (!unreadEmails || unreadEmails.length === 0) {
                        <div class="flex flex-col items-center justify-center py-12 px-6">
                            <div class="flex h-14 w-14 flex-0 items-center justify-center rounded-full bg-green-100 dark:bg-green-900">
                                <mat-icon class="text-green-600 dark:text-green-400" [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
                            </div>
                            <div class="mt-5 text-xl font-semibold tracking-tight">
                                All caught up!
                            </div>
                            <div class="text-gray-500 dark:text-gray-400 mt-1 text-center text-sm">
                                No unread messages in your inbox.
                            </div>
                            <button 
                                mat-flat-button 
                                color="primary" 
                                class="mt-4"
                                (click)="openMailbox()"
                            >
                                Open Mailbox
                            </button>
                        </div>
                    }
                </div>

                <!-- Footer with link to full mailbox -->
                @if (unreadEmails && unreadEmails.length > 0) {
                    <div class="border-t p-4">
                        <button 
                            mat-stroked-button 
                            class="w-full"
                            (click)="openMailbox()"
                        >
                            View all messages
                        </button>
                    </div>
                }
            }
        </div>
    </div>
</ng-template>
